import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Row, Col } from 'core/components/ui'
import SVG from 'core/components/svg'
import svg from 'assets/svg'
import { font } from 'assets/themes/theme-default'

const TiltleIcon = styled(SVG)`
  width: 30px;
  fill: ${props => props.theme.colors.color1.bg};
  margin-right: 10px;
`
const TitleWrapper = styled(Row)`
  margin: 20px 0;
`

const Title = styled.h4`
  font-size: ${props => (props.small ? font.size.lgxxs : font.size.lgsm)};
`

const TitleIcon = props => {
  const { title, small } = props

  return (
    <TitleWrapper type="flex" align="middle" data-test="component-title-icon">
      <Col>
        <TiltleIcon svg={svg.questionMark} data-test="title-icon-svg" />
      </Col>
      <Col>
        <Title small={small} data-test="title-icon-title">
          {title}
        </Title>
      </Col>
    </TitleWrapper>
  )
}

TitleIcon.defaultProps = {
  title: null,
  small: false
}
TitleIcon.propTypes = {
  title: PropTypes.string,
  small: PropTypes.bool
}

export default TitleIcon
